export enum EActionTypes {
  CREATE_ACCOUNT = 'CREATE_ACCOUNT',
  CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS',
  CREATE_ACCOUNT_FAILURE = 'CREATE_ACCOUNT_FAILURE',
  CLEAR_ACCOUNT_ERRORS = 'CLEAR_ACCOUNT_ERRORS',
}
